import React, { useState } from "react";
import MuiAlert from "@material-ui/lab/Alert";
import { Snackbar } from "@material-ui/core";

const ToastContext = React.createContext({
  openToast: (message, severity, config) => {},
});

const Alert = (props) => {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
};

const toastInitState = {
  message: "Message not set.",
  severity: "success", // error , warning, info
  duration: 4000,
  verticalPosition: "top", // bottom
  horizontalPosition: "center", // left , right
  autoClose: true
};


export const ToastContextProvider = (props) => {
  const [show, setShow] = useState(false);
  const [toastProps, setToastProps] = useState(toastInitState);

  const openToast = (
    message = "Message not set.",
    severity = "success",
    config = {}
  ) => {
    setToastProps((curr) => {
      const newConf = {
        ...toastInitState,
        ...config,
        message,
        severity,
        key: new Date().getTime(),
      };
      newConf.duration = newConf.autoClose ? newConf.duration : null
      return newConf;
    });
    setShow(true);
  };

  const closeToast = () => {
    setShow(false);
  };

  return (
    <ToastContext.Provider value={{ openToast }}>
      <Snackbar
        open={show}
        autoHideDuration={toastProps.duration}
        ClickAwayListenerProps={{ mouseEvent: false }}
        onClose={closeToast}
        key={toastProps.key}
        anchorOrigin={{
          vertical: toastProps.verticalPosition,
          horizontal: toastProps.horizontalPosition,
        }}>
        <Alert onClose={closeToast} severity={toastProps.severity}>
          {toastProps.message}
        </Alert>
      </Snackbar>
      {props.children}
    </ToastContext.Provider>
  );
};

export default ToastContext;
